<template>
    <span class="yes-no-wrapper">
        <hh-radio class="form__radio-list--yes-no --yes-no"
                  :def="def"
                  :intro-text="introText"
                  :options="options"
                  :value="value"
                  :disabled="disabled"
                  :horizontal-layout="horizontalLayout"
                  @change="$emit('change', $event)"
                  @input="$emit('input', $event)"
                  @keydown="$emit('keydown', $event)"
                  @keypress="$emit('keypress', $event)"
                  @keyup="$emit('keyup', $event)"
                  @keyup.enter="$emit('keyup.enter', $event)"
                  @mousedown="$emit('mousedown', $event)"
                  @mouseover="$emit('mouseover', $event)"
                  @mouseup="$emit('mouseup', $event)"
                  @touchstart="$emit('touchstart', $event)"
                  @touchend="$emit('touchend', $event)"
                  @touchcancel="$emit('touchcancel', $event)">
            <slot />
        </hh-radio>
    </span>
</template>

<script>

import FormControl from './form-control'
import ResourcesHelper from '@/components/resources-helper'

export default {

    props: {
        introText: {
            type: String,
            default: '',
        },
        value: {
            type: [ String, Boolean ],
            default: null,
        },
        horizontalLayout: {
            type: Boolean,
            default: false,
        },
        reverseOptions: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [
        FormControl,
        ResourcesHelper,
    ],

    computed: {

        options() {
            const options = [ {
                key: 'yes',
                text: this.commonResources.yes,
                value: true,
            }, {
                key: 'no',
                text: this.commonResources.no,
                value: false,
            } ]

            if (this.reverseOptions)
                options.reverse()

            return options
        },
    },
}

</script>
